<template>
  <div>
    <el-card class="m-auto p-3 border welcome-card">
      <i class="el-icon-sunny d-block icon-size-md font-color-primary mb-2"></i>
      <vue-typer class="font-weight-bold" :text="welcomeText" :repeat="0"></vue-typer>
      <br />
      <vue-typer :pre-type-delay="2500" :text="$t('general.how_are_you')" :repeat="0"></vue-typer>
    </el-card>

    <el-card class="mt-5 mx-2">
      <News />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import News from './News';
export default {
  name: 'DashboardView',
  components: { News },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.USER, ['fullName']),
    welcomeText() {
      return this.$t('general.welcome_message', { name: this.fullName });
    },
  },
  methods: {},
};
</script>

<style scoped>
.welcome-card {
  max-width: 500px;
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
